var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCriticalWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2746",
    "data-name": "\\uADF8\\uB8F9 2746",
    transform: "translate(-819 -294.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1026",
    "data-name": "\\uADF8\\uB8F9 1026",
    transform: "translate(16.5 1.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_111",
    "data-name": "\\uD0C0\\uC6D0 111",
    transform: "translate(805.079 300.366)",
    fill: "#8c1c03",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.073,
    cy: 8.859,
    rx: 10.073,
    ry: 8.859,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.073,
    cy: 8.859,
    rx: 9.573,
    ry: 8.359,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-checkmark-circle",
    "data-name": "Icon ionic-ios-checkmark-circle",
    d: "M15.875,3.375a12.5,12.5,0,1,0,12.5,12.5A12.5,12.5,0,0,0,15.875,3.375Zm6.4,9.044L14.24,20.49h-.006a1.085,1.085,0,0,1-.7.331,1.052,1.052,0,0,1-.7-.343L9.469,17.113a.239.239,0,0,1,0-.343l1.07-1.07a.232.232,0,0,1,.337,0l2.668,2.668,7.332-7.386a.237.237,0,0,1,.168-.072h0a.218.218,0,0,1,.168.072l1.052,1.088A.237.237,0,0,1,22.275,12.419Z",
    transform: "translate(799.125 293.35)",
    fill: "#8c1c03"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "!",
    transform: "translate(828.5 319.375)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "!")), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": "!",
    transform: "translate(828.5 319.375)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "!")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalWarning);
export default __webpack_public_path__ + "static/media/critical_warning.a47f3f9ad2edd7c70c10693b05003819.svg";
export { ForwardRef as ReactComponent };